import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type UserLimitDirectBuyModalComponent = EntryPointComponent<
	Record<string, never>,
	Record<string, never>,
	{ onClose: (extraInformation?: unknown) => void },
	Record<string, never>
>;

export const entryPoint: EntryPoint<
	UserLimitDirectBuyModalComponent,
	Record<string, never>
> = createEntryPoint({
	root: JSResourceForInteraction<UserLimitDirectBuyModalComponent>(
		/* webpackChunkName: "@atlaskit-internal_edition-awareness-user-limit-direct-buy-modal" */ './user-limit-direct-buy-modal-content',
		{ moduleId: 'edition-awareness-user-limit-direct-buy-modal' },
	),
	getPreloadProps: () => ({ entryPoints: {}, extraProps: {}, queries: {} }),
});
